import { observer } from 'mobx-react';
import { Participant } from '../../../../../../../ParticipantsStore/Types';
import { T } from '../../../../../../../Translations';
import Avatar, { statusLabel } from './Avatar';

interface Props {
  participant: Participant;
}

const nonBlank = (value: string): boolean => value.trim().length > 0;

function PersonCell({ participant }: Props) {
  const { email, status } = participant;
  const name = participant.fullName.filter(nonBlank).getOrElseValue(email);
  const initials = participant.initials
    .filter(nonBlank)
    .getOrElse(() => email.charAt(0).toUpperCase());

  return (
    <div className="flex min-w-0 items-center gap-3">
      <Avatar initials={initials} status={status} />
      <div className="min-w-0">
        <div
          className="truncate text-foreground"
          style={{ fontWeight: 'var(--font-weight-medium)' }}
        >
          {name}
          <span className="sr-only">
            <T kind={statusLabel(status)} />
          </span>
        </div>
        <div className="truncate text-muted-foreground" style={{ fontSize: 'var(--text-sm)' }}>
          {email}
        </div>
      </div>
    </div>
  );
}

export default observer(PersonCell);
